import type { ParentAttendanceSummary } from '@repo/types/parent';
import type { UserPublic } from '@repo/types/users';

import type { ChildrenResourceResult } from './useChildrenResource';

import { ParentKey } from './keys';
import { ParentService } from './parentService';
import { useChildrenResource } from './useChildrenResource';

/**
 * Global attendance summary of every linked child, aggregated.
 */
export function useGetChildrenAttendanceSummary(children: UserPublic[], enabled = true): ChildrenResourceResult<ParentAttendanceSummary> {
  return useChildrenResource(
    children,
    (child) => [ParentKey.CHILD_ATTENDANCE_SUMMARY, child.id],
    (child) => ParentService.getChildAttendanceSummary(child.id).then((response) => response.data),
    enabled
  );
}
